import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Logout from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signOut } from '../../actions/accountActions';
import LoadingBackdrop from '../../load/loadingBackdrop';
import ButtonSwitch from '../gestAdmin/privilegios/buttonSwitch';
import VerifyPermission from '../../utils/verifyPermission';

export default function UserAdmin() {
    const user = useSelector(state => state.account.user);
    const [permissions, setPermissions] = React.useState(user?.permissions)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const [load, setLoad] = React.useState(false)

    const handleSignOut = () => {
        setLoad('A terminar sessão')

        setTimeout(() => {
            dispatch(signOut());
            handleClose();
            navigate('/login')
            window.location.reload()

            dispatch({
                type: 'alert',
                payload: { alert: 'Sessão terminada' },
            });
        }, 4000);
    };

    return (
        <React.Fragment>
            <LoadingBackdrop text={load} open={!!load} />

            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>

                <Tooltip title="Definiçōes de conta">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        // sx={{ ml: 1 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <Avatar
                            // sx={{ width: 32, height: 32 }}
                            alt={user?.dadosPessoais?.nome}
                            src={user?.dadosPessoais?.fotoURL}
                            style={{ cursor: 'pointer' }}
                        />
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                // onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&::before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={() => navigate('/admin/perfil-admin')}>
                    <Avatar
                        // sx={{ width: 32, height: 32 }}
                        alt={user?.dadosPessoais?.nome}
                        src={user?.dadosPessoais?.fotoURL}
                        style={{ cursor: 'pointer' }}
                    />
                    Meu Perfil
                </MenuItem>


                <VerifyPermission permissions={user?.permissions} permission={'allPermissions'}>
                    <Divider />

                    <MenuItem disabled>
                        <b>MODULOS</b>
                    </MenuItem>
                    <MenuItem >
                        <ButtonSwitch
                            adminId={user._id}
                            permission={'secçãoLicenciamento'}
                            permissions={permissions}
                            setPermission={setPermissions}
                            title={'LICENCIAMENTO'}
                            descricao={''}
                            width={'auto'}
                            verificacaoSimples={true}
                        />
                    </MenuItem>
                    <MenuItem >
                        <ButtonSwitch
                            adminId={user._id}
                            permission={'secçãoCertificadoProdutoControlo'}
                            permissions={permissions}
                            setPermission={setPermissions}
                            title={'PRODUTO CONTROLADO'}
                            descricao={''}
                            width={'auto'}
                            verificacaoSimples={true}
                        />
                    </MenuItem>
                    <MenuItem >
                        <ButtonSwitch
                            adminId={user._id}
                            permission={'secçãoImportação'}
                            permissions={permissions}
                            setPermission={setPermissions}
                            title={'IMPORTAÇÃO'}
                            descricao={''}
                            width={'auto'}
                            verificacaoSimples={true}
                        />
                    </MenuItem>
                    <MenuItem >
                        <ButtonSwitch
                            adminId={user._id}
                            permission={'secçãoDesalfandegamento'}
                            permissions={permissions}
                            setPermission={setPermissions}
                            title={'DESALFANDEGAMENTO'}
                            descricao={''}
                            width={'auto'}
                            verificacaoSimples={true}
                        />
                    </MenuItem>
                    <MenuItem >
                        <ButtonSwitch
                            adminId={user._id}
                            permission={'secçãoExpediente'}
                            permissions={permissions}
                            setPermission={setPermissions}
                            title={'EXPEDIENTE'}
                            descricao={''}
                            width={'auto'}
                            verificacaoSimples={true}
                        />
                    </MenuItem>
                    <MenuItem >
                        <ButtonSwitch
                            adminId={user._id}
                            permission={'secçãoControleQualidade'}
                            permissions={permissions}
                            setPermission={setPermissions}
                            title={'CONTROLE DE QUALIDADE'}
                            descricao={''}
                            width={'auto'}
                            verificacaoSimples={true}
                        />
                    </MenuItem>
                    <MenuItem >
                        <ButtonSwitch
                            adminId={user._id}
                            permission={'secçãoFarmacovigilância'}
                            permissions={permissions}
                            setPermission={setPermissions}
                            title={'FARMACOVIGILÂNCIA'}
                            descricao={''}
                            width={'auto'}
                            verificacaoSimples={true}
                        />
                    </MenuItem>
                    <MenuItem >
                        <ButtonSwitch
                            adminId={user._id}
                            permission={'secçãoMedicamentos'}
                            permissions={permissions}
                            setPermission={setPermissions}
                            title={'MEDICAMENTOS'}
                            descricao={''}
                            width={'auto'}
                            verificacaoSimples={true}
                        />
                    </MenuItem>


                    <Divider />
                    <MenuItem onClick={() => navigate('/admin/definicoes/sistema')}>
                        <ListItemIcon>
                            <SettingsIcon fontSize="small" />
                        </ListItemIcon>
                        Definições de sistema
                    </MenuItem>
                </VerifyPermission>

                <Divider />
                <MenuItem onClick={handleSignOut}>
                    <ListItemIcon>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                    Terminar sessão
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}
